import { Environment } from 'types/config';
import type { Delegator } from '@viome/viome-base/src/utils/environment/Environment.model';
import environment from '@viome/viome-base/src/utils/environment';

const env = import.meta.env as unknown as Environment;

type EnvValues = {
  GTM_CONTAINER_ID: string;
  GTM_AUTH: string;
  GTM_PREVIEW: string;
  GA_TRACKING_ID: string;
  SENTRY_DSN: string;
  SENTRY_RELEASE_ID: string;
  SENTRY_TRACES_SAMPLE_RATE: string;
  ENVIRONMENT: string;
  STATSIG_API_KEY: string;
  STATSIG_ENVIRONMENT: string;
  BASE_URL: string;
  AUTH_URL: string;
  OLD_BASE_URL: string;
  [key: string]: string;
};

const ENV_VALUES: EnvValues = {
  GTM_CONTAINER_ID: env.VITE_GTM_CONTAINER_ID,
  GTM_AUTH: env.VITE_GTM_AUTH,
  GTM_PREVIEW: env.VITE_GTM_PREVIEW,
  GA_TRACKING_ID: env.VITE_GA_TRACKING_ID,
  SENTRY_DSN: env.VITE_SENTRY_DSN,
  SENTRY_RELEASE_ID: env.VITE_SENTRY_RELEASE_ID,
  SENTRY_TRACES_SAMPLE_RATE: env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  ENVIRONMENT: env.VITE_ENVIRONMENT,
  STATSIG_API_KEY: env.VITE_STATSIG_API_KEY,
  STATSIG_ENVIRONMENT: env.VITE_STATSIG_ENVIRONMENT,
  BASE_URL: env.VITE_BASE_URL,
  AUTH_URL: env.VITE_AUTH_URL,
  OLD_BASE_URL: env.VITE_OLD_BASE_URL,
};

export default ENV_VALUES;

const environmentDelegator: Delegator = {
  get: (key: string) => ENV_VALUES[key],
};

environment.setDelegator(environmentDelegator);
